import axios from "axios";
import { useState, useEffect, useRef } from "react";

//import { styleTabs } from '@/utils/Styles';
//const Tabs = lazy(() => import('@mui/material/Tabs'));
//const Tab = lazy(() => import('@mui/material/Tab'));
import {
    Card,
    CardContent,
    CardActionArea,
    Breadcrumbs,
    Link,
    Grid,
    Box,
    Backdrop,
    CircularProgress
} from '@mui/material';
import { styleCards, getBreadcrumbsStyle, styleBackdrop } from '@/utils/Styles';

import { 
    Handyman as ResourceIcon,
    Undo as BackIcon,
    Home as HomeIcon,
    FilterAlt as FilterIcon,
    FilterAltOff as FilterOffIcon,
    ArrowUpward as UpIcon,
    Refresh as RefreshIcon
} from '@mui/icons-material';

import Input from '@/components/Input';
import Button from '@/components/Button';

import Resource from '@/pages/Resources/Resource';

import ResourceRentalModal from '@/modals/Resources/ResourceRentalModal';
import ResourceInfoModal from '@/modals/Resources/ResourceInfoModal';
import ResourceEventsModal from '@/modals/Resources/ResourceEventsModal';
import ResourceMaintenanceModal from '@/modals/Resources/ResourceMaintenanceModal';
import ResourceBookingModal from '@/modals/Resources/ResourceBookingModal';
import ResourceEventsInfoModal from '@/modals/Resources/ResourceEventsInfoModal';

import { /*getCurrentTab, getNewUrl,*/getCurrentOptions, setNewOptions } from '@/utils/Tabs';

import { getErrorMessage } from '@/utils/Errors';
import { getPlanUrl, getParameterURL, addParameterURL } from '@/utils/URL';
import { getTableConfig, setTableConfig, removeTableConfig } from '@/utils/Table';

export default function Resources({ t, language, user, apiUrl, token, 
    router, sendMessage, handleLogin, fullScreen, openUrlModal
}) {

    const resourcesRef = useRef(null);

    const { sxBreadcrumbsResources } = getBreadcrumbsStyle();

    const [ manage, setManage ] = useState(null);

    const [ resource, setResource ] = useState(null);
    const [ resources, setResources ] = useState([]);
    const [ resourcesFiltered, setResourcesFiltered ] = useState([]);

    //const { sxTabs, sx, sxIcon } = styleTabs();
    const { sxCardAction, sxCard } = styleCards();

    const { sxBackdrop } = styleBackdrop();
    
    //const [ tabs, setTabs ] = useState([]);
    //const [ tabsNames, setTabsNames ] = useState([]);
    //const [ tab, setTab ] = useState(null);
    
    // using tiles
    const [ groupAll ] = useState({id: 0, name: 'all'});
    const [ subgroupAll ] = useState({id: 0, name: 'all'});
    const [ groups, setGroups ] = useState(null);
    const [ subgroups, setSubgroups ] = useState(null);

    const [ config, setConfig ] = useState(null);

    const [ group, setGroup ] = useState(null);
    const [ subgroup, setSubgroup ] = useState(null);
    const [ hasSubgroups, setHasSubgroups ] = useState(false);

    const [ users, setUsers ] = useState(null);
    const [ plans, setPlans ] = useState(null);

    const [ searchText, setSearchText ] = useState('');
    const [ filtersApplied, setFiltersApplied ] = useState(true);
    
    // fo filter by status
    const [ status, setStatus ] = useState(getParameterURL(router,'status'));
    const [ statuses ] = useState(['all','available','rented','maintenance','booking']);

    const handleStatus = (newStatus) => {
        setStatus(newStatus);
        handleURLAddParam('status',newStatus);
        filterResources(resources,group,subgroup,newStatus,false);
    }

    // to scroll to top
    const handleScroll = () => {
        
        if(resourcesRef.current){
            
            resourcesRef.current.scrollIntoView({
                top: '200px',
                behavior: 'smooth',
            });
        }
    };

    // to refresh data
    const handleRefresh = () => {
        getData();
    };

    // to filter resources
    const filterResources = (resourcesInfo, groupInfo, subgroupInfo, statusInfo, clear, text = null) => {

        const newResourcesFiltered = [];
        resourcesInfo && resourcesInfo?.length > 0 &&
        resourcesInfo?.forEach((item) => {

            if(
                (
                    groupInfo?.id === 0 || 
                    (
                        item?.group?.id === groupInfo?.id && 
                        (
                            subgroupInfo?.id === 0 || 
                            item?.subgroup?.id === subgroupInfo?.id
                        )
                    )
                ) &&
                (
                    clear ||
                    (
                        text === null && (!searchText || searchText?.length === 0)
                    ) ||    
                    (              
                        text && text?.length > 0 &&
                        (
                            item?.name?.toLowerCase().includes(text?.toLowerCase()) ||
                            (
                                item?.code && item.code?.length > 0 &&
                                item?.code?.toLowerCase().includes(text?.toLowerCase())
                            )
                        )
                    ) ||
                    (              
                        searchText && searchText?.length > 0 &&
                        (
                            item?.name?.toLowerCase().includes(searchText?.toLowerCase()) ||
                            (
                                item?.code && item.code?.length > 0 &&
                                item?.code?.toLowerCase().includes(searchText?.toLowerCase())
                            )
                        )
                    )
                ) &&
                (
                    !statusInfo ||
                    statusInfo === 'all' ||
                    (statusInfo === 'available' && !item?.situation?.rented && !item?.situation?.maintenance && !item?.situation?.booking) ||
                    (statusInfo === 'rented' && item?.situation?.rented) ||
                    (statusInfo === 'maintenance' && item?.situation?.maintenance) ||
                    (statusInfo === 'booking' && item?.situation?.booking)
                )
            ){
                newResourcesFiltered.push(item);
            }
            
        });

        setResourcesFiltered(newResourcesFiltered);

    }

    const handleSearchInput = (e) => {
        
        //var name = e.target.name;
        var value = e.target.value;

        setSearchText(value);
    };

    const handleSearch = () => {

        if(searchText && searchText?.length > 0){
            // filter
            handleURLAddParam('search',searchText);
            filterResources(resources,group,subgroup,status,false);
            setFiltersApplied(true);
        }
        else{            
            handleSearchClear(resources,group,subgroup,status);
        }
    };

    // add parameter to the url
    const handleURLAddParam = (name,value) => {
		const url = addParameterURL(router.pathname,router.searchParams,name,value);
		router.navigate(url);
		//window.history.pushState({path:url?.href},'',url?.href);
	}

    const handleSearchClear = (resourcesInfo,groupInfo,subgroupInfo,statusInfo,initial,changeUrl = false) => {          

        // if initial search
        if(initial){
            applyInitialSearch(resourcesInfo,groupInfo,subgroupInfo,statusInfo);
        }
        else{
            setSearchText('');
            setFiltersApplied(false);
            if(changeUrl){
                handleURLAddParam('search','');
            }
            removeTableConfig(user,'resource_rentals','quickFilterText');

            filterResources(resourcesInfo,groupInfo,subgroupInfo,statusInfo,true);
        }

        // scroll to top
        handleScroll();
    };

    // submit with enter on the searh box
    const handleSearchKeyDown = (event) => {

        if (event.keyCode === 13) {
            handleSearch();
        }
    }

    // make initial search
    const applyInitialSearch = (resourcesInfo,groupInfo,subgroupInfo,statusInfo) => {
        
        var searchParam = getParameterURL(router,'search');
        
        // if receiving search by get parameter
        let filtersApplied = false;
        let searchText = '';
        if(searchParam && searchParam?.length > 0){

            searchText = searchParam;

            // save on config to recover later			
            setTableConfig(null,user,'resource_rentals','quickFilterText',searchParam);

            filtersApplied = true;
        }
        else{
        
            // check if quick search saved
            var savedSearch = getTableConfig(user,'resource_rentals','quickFilterText');
            if(savedSearch && savedSearch?.length > 0){
                searchText = savedSearch;
                filtersApplied = true;
            }
        }

        if(filtersApplied){
            setFiltersApplied(true);
            setSearchText(searchText);
            filterResources(resourcesInfo,groupInfo,subgroupInfo,statusInfo,false,searchText);
        }
        else{
            filterResources(resourcesInfo,groupInfo,subgroupInfo,statusInfo,true);
        }
    }

    /*
    const handleTabChange = (event, newValue) => {
        
        setTab(newValue);        
        const url = getNewUrl(router,'resource_rentals',tabs,newValue);
        router.navigate(url);
        //window.history.pushState({path:url},'',url);
    };

    // detect tab reclick
    const handleTabReClick = (clickedTabValue) => {
        console.log(clickedTabValue);
    }
    */

    const setCurrentOption = (resourcesInfo,groupsArray,subgroupsArray) => {

        var newGroup = null;
        var newSubgroup = null;
        
        if(router.pathname && groupsArray && groupsArray?.length > 0){

            const currentOptions = getCurrentOptions(router,'resource_rentals');

            if(currentOptions && currentOptions?.length > 0){                

                // group
                const currentGroup = parseInt(currentOptions[0]);  

                // it means all items
                if(currentGroup === 0){
                    newGroup = groupAll;
                }
                else{    

                    const getGroup = groupsArray?.filter((item) => item?.id === currentGroup);  

                    if(getGroup && getGroup?.length > 0){
                        
                        newGroup = getGroup[0];                        
                    
                        // if group found
                        if(currentOptions?.length > 1){

                            // subgroup
                            const currentSubgroup = parseInt(currentOptions[1]);

                            // it means all items
                            if(currentSubgroup === 0){
                                newSubgroup = subgroupAll;
                            }
                            else{
                                if(subgroupsArray && subgroupsArray?.length > 0){  

                                    const getSubgroup = subgroupsArray?.filter((item) => item?.id === currentSubgroup && item?.parent === currentGroup);  

                                    if(getSubgroup && getSubgroup?.length > 0){                                    
                                        newSubgroup = getSubgroup[0];
                                    } 
                                }     
                            }
                        }
                    }
                }
            }
        }        

        setGroup(newGroup);
        setSubgroup(newSubgroup);
        handleSearchClear(resourcesInfo,newGroup,newSubgroup,status,true);

        if(newSubgroup){                
            setHasSubgroups(true);
        }
        else{
            const isSubgroups = subgroupsArray?.some((item) => item?.parent === newGroup?.id);                            
            setHasSubgroups(isSubgroups);
        }  
    }

    // if clicking on the menu, clear group and subgroup
    useEffect(() => {
        
        if(router.pathname === '/resource_rentals'){
            setGroup(null);
            setSubgroup(null);
            setHasSubgroups(false);
        }

    }, [router.pathname]);

    // check resources statuses
    const checkResources = (resourcesArray) => {

        const resourcesInfo = [];

        if(resourcesArray && resourcesArray?.length > 0){

            resourcesArray?.forEach((item,index) => {

                var newResource = item;                                
                var rented = false;
                var maintenance = false;
                var booking = false;
                var locationUrl = null;
                
                // already ordered from backend
                //var orderedEvents = null;
                var latestEvent = null;
                if(newResource?.events && newResource.events?.length > 0){

                    // if no events, resource available                    
                    /*
                    orderedEvents = [...newResource.events]?.sort((a, b) => {
                        // Convert date properties to numerical timestamps for comparison
                        const dateA = new Date(a?.date).getTime() ?? 0;
                        const dateB = new Date(b?.date).getTime() ?? 0;
                      
                        return dateB - dateA;
                    });                    
                    orderedEvents = newResource?.events;                    
                    latestEvent = orderedEvents[0];
                    */
                   latestEvent = newResource?.events[0];
                }

                // we save the position in case we edit, to update the item without reloading the page
                newResource.index = index;

                if(latestEvent){

                    if(latestEvent?.plan){
                        locationUrl = getPlanUrl(latestEvent?.plan);
                    }

                    switch(latestEvent?.status?.type){

                        case 'planin':
                            rented = true;
                            break;

                        case 'maintenancein':
                            maintenance = true;
                            break;

                        case 'bookingin':
                            booking = true;
                            break;
                    }

                }
                
                newResource.situation = {
                    event: latestEvent,
                    location: locationUrl,
                    rented: rented,
                    maintenance: maintenance,
                    booking: booking
                };

                // get cover file
                if(newResource?.files && newResource?.files?.length > 0){
                    /*
                    const covers = newResource.files?.filter(info => info?.type === 'image');

                    if(covers && covers?.length > 0){
                        newResource.cover = covers[0]?.path;
                    }
                    */
                    newResource.cover = newResource?.files[0];
                }  

                resourcesInfo.push(newResource);        
            });
        }

        return resourcesInfo;
    }

    // if only one item
    const checkResource = (resourceInfo) => {

        var resourceUpdated = resourceInfo;

        const resourcesUpdated = checkResources([resourceInfo]);

        if(resourcesUpdated && resourcesUpdated?.length > 0){
            resourceUpdated = resourcesUpdated[0];
        }

        return resourceUpdated;
    }

    // to change the url
    const changeUrl = (groupInfo = null, subgroupInfo = null) => {

        const options = [];
        
        if(groupInfo){
            options.push(groupInfo?.id);
        }

        if(subgroupInfo){
            options.push(subgroupInfo?.id);
        }

        const url = setNewOptions(router,'resource_rentals',options);  
            
        router.navigate(url);        
    }

    const handleGroup = (groupInfo) => {        
        
        setStatus(null);
        setGroup(groupInfo);

        var subgroupInfo = subgroup;

        // check if group does not have subgroups. select all by default
        if(groupInfo?.id !== 0){
            
            const isSubgroups = subgroups?.some((item) => item?.parent === groupInfo?.id);        
            setHasSubgroups(isSubgroups);

            if(!isSubgroups){
                subgroupInfo = subgroupAll;
                setSubgroup(subgroupAll);
            }
        }

        // change url        
        changeUrl(groupInfo);

        handleSearchClear(resources,groupInfo,subgroupInfo,null);
    }

    const handleSubgroup = (subgroupInfo) => {
        
        setStatus(null);
        setSubgroup(subgroupInfo);

        // change url        
        changeUrl(group,subgroupInfo);

        handleSearchClear(resources,group,subgroupInfo,null);
    }

    const handleHomeBreadcrumb = () => {
            
        setStatus(null);
        setGroup(null);
        setSubgroup(null);

        // change url        
        changeUrl();

        handleSearchClear(resources,null,null,null);
    }

    const handleGroupBreadcrumb = () => { 

        setStatus(null);       
        
        var subgroupInfo = subgroup;        
        
        if(hasSubgroups){
            subgroupInfo = null;
            setSubgroup(null);                        
        }

        // change url
        changeUrl(group);

        handleSearchClear(resources,group,subgroupInfo,null);
    }

    const handleSubgroupBreadcrumb = () => {
        setStatus(null);
        handleSearchClear(resources,group,subgroup,null);
    }

    const handleBack = (isSubgroup = false) => {  

        setStatus(null);

        var groupInfo = group;             

        // return back
        setSubgroup(null);

        // if back on group
        if(!isSubgroup){
            
            groupInfo = null;
            setGroup(null);

            // change url
            changeUrl();
        }
        else{
            // change url
            changeUrl(group);
        }

        handleSearchClear(resources,groupInfo,null,null);
    }

    const getData = () => {
            
        const apiPath = '/resource_rentals/list';

        const config = {
            headers: { Authorization: `Bearer ${token}` },   
            // params is the same as using ?database=, query params      
            params: {
                language: language,
                companyuser: user?.company
            }  
        };

        var errorMessage = t('resource_rentals.resources.error');
        
        axios.get(apiUrl+apiPath,config)
        .then(function (response) {

            if(response?.data){
          
                const responseData = response.data;                

                // if result is ok (1)
                if(responseData?.result){

                    const getData = responseData?.data;

                    // check resources and add extra info
                    const resourcesInfo = checkResources(getData?.items);

                    setResources(resourcesInfo);                    
                    
                    if(getData?.groups && getData?.groups?.length > 0){
            
                        /*
                        const tabsList = getData?.groups.map(group => group?.id?.toString());             
                        setTabs(tabsList);
                        
                        const tabsNames = getData?.groups.map(group => group?.name); 
                        setTabsNames(tabsNames);
                        
                        const currentTab = getCurrentTab(router,tabsList);            
                        setTab(currentTab);   
                        */                         
                        
                        // set group and subgroup depending on the url
                        setCurrentOption(resourcesInfo,getData?.groups,getData?.subgroups);

                        setGroups(getData?.groups);
                        setSubgroups(getData?.subgroups); 
                    }
                    else{
                        /*
                        setTabs([]);
                        setTabsNames([]);
                        setTab(null);
                        */
                        setGroups([]);
                        setSubgroups([]);
                        setGroup(null);
                        setSubgroup(null);
                    }

                    if(getData?.users && getData?.users?.length > 0){
                        setUsers(getData.users);
                    }
                    else{
                        setUsers(null);
                    }

                    if(getData?.plans && getData?.plans?.length > 0){
                        setPlans(getData.plans);
                    }
                    else{
                        setPlans(null);
                    }

                    if(getData?.config && getData?.config?.length > 0){
                        setConfig(getData.config);
                    }
                    else{
                        setConfig(null);
                    }

                    if(Object?.hasOwn(getData,'manage')){
                        setManage(getData.manage ? true : false);
                    }
                    else{
                        setManage(false);
                    }                    
                } 
                else{
                    if(responseData?.status && responseData.status === 401){
                        handleLogin();                        
                    }
                    else{
                        // check error message
                        if(responseData?.data?.reasons){
                            errorMessage = getErrorMessage(t,'resource_rentals.resources',responseData?.data?.reasons);                                
                        }
                        
                        sendMessage(errorMessage,'error');
                    }                        
                }
            }
            else{                
                sendMessage(errorMessage,'error');                    
            }
        })
        .catch(function (error){
            
            if(error?.status && error.status === 401){
                handleLogin();                        
            }
            else{                        
                sendMessage(errorMessage,'error');
            }
        });
    }

    // get data
    useEffect(() => {  
        getData();
    }, []);

    // to show the resource info
    const [ showResourceInfoModal, setShowResourceInfoModal ] = useState(false);
    
    const handleResourceInfo = (resourceElement) => {
        setResource(resourceElement);
        setShowResourceInfoModal(true);
    }    

    // to show the resource rental events
    const [ showResourceEventsModal, setShowResourceEventsModal ] = useState(false);

    const handleResourceEvents = (resourceElement) => {
        setResource(resourceElement);
        setShowResourceEventsModal(true);
    }

    // to show the resource rental events extra info
    const [ showResourceEventsInfoModal, setShowResourceEventsInfoModal ] = useState(false);

    const [ resourceEvent, setResourceEvent ] = useState(null);
    const handleResourceEventsInfo = (event) => {
        setResourceEvent(event);
        setShowResourceEventsInfoModal(true);
    }

    // to show the resource maintenance form
    const [ showResourceMaintenanceModal, setShowResourceMaintenanceModal ] = useState(false);

    const handleResourceMaintenance = (resourceElement) => {

        // if resource rented, cannot move to maintenance
        // show rental modal instead of maintenance modal to create return
        // rental modal directly creates event for return and auto event for maintenance
        if(resourceElement?.situation?.rented){
            //sendMessage(t('resource_rentals.maintenance.in.rented'),'error');
            setResource(resourceElement);
            setShowResourceRentalModal(true);
        }
        else{
            // if booking requested, do not allow to enter maintenance
            if(resourceElement?.situation?.booking){
                sendMessage(t('resource_rentals.maintenance.errors.booking'),'error');
            }
            else{
                setResource(resourceElement);
                setShowResourceMaintenanceModal(true);
            }
        }
    }

    // to show the resource modal with the info
    const [ showResourceRentalModal, setShowResourceRentalModal ] = useState(false);

    const handleResourceRental = (resourceElement) => {
        setResource(resourceElement);
        setShowResourceRentalModal(true);
    }

    // to show the resource booking form
    const [ showResourceBookingModal, setShowResourceBookingModal ] = useState(false);

    const handleResourceBooking = (resourceElement) => {
        setResource(resourceElement);
        setShowResourceBookingModal(true);
    }

    // if resources changed when loaded or when changed on maintenance, etc., change filtered
    // changed is the changed resource
    const [ changed, setChanged ] = useState(null);
    useEffect(() => {
        
        if(changed){
            
            // add extra info to the resource
            const newResource = checkResource(changed);
            
            // update filtered if there
            const resourceFilteredIndex = resourcesFiltered.findIndex(
                (item) => item.id === changed.id
            );

            if(resourceFilteredIndex !== null){
                const newResourcesFiltered = [...resourcesFiltered];                            
                newResourcesFiltered[resourceFilteredIndex] = newResource;
                setResourcesFiltered(newResourcesFiltered);
            }

            // update on the resources list            
            const resourceIndex = resources.findIndex(
                (item) => item.id === changed.id
            );

            if(resourceIndex !== null){
                const newResources = [...resources];                            
                newResources[resourceIndex] = newResource;
                setResources(newResources);
            }

            setChanged(null);
        }        

    },[changed]);

    return (
        <>        
        <ResourceInfoModal 
            t={t}
            open={showResourceInfoModal} 
            setOpen={setShowResourceInfoModal}  
            resource={resource}
            fullScreen={fullScreen}
            openUrlModal={openUrlModal}
        /> 
        <ResourceEventsModal 
            t={t}
            open={showResourceEventsModal} 
            setOpen={setShowResourceEventsModal}  
            resource={resource}
            fullScreen={fullScreen}
            handleInfo={handleResourceEventsInfo}
        />
        <ResourceEventsInfoModal 
            t={t}
            open={showResourceEventsInfoModal} 
            setOpen={setShowResourceEventsInfoModal}  
            resource={resource}
            event={resourceEvent}
            fullScreen={fullScreen}
            openUrlModal={openUrlModal}            
        />
        <ResourceRentalModal 
            t={t}
            open={showResourceRentalModal} 
            setOpen={setShowResourceRentalModal}              
            resource={resource} 
            setChanged={setChanged}
            fullScreen={fullScreen}
            user={user}
            token={token}
            apiUrl={apiUrl}
            language={language}
            sendMessage={sendMessage}
            handleLogin={handleLogin}
            users={users}
            plans={plans}
            config={config}
            openUrlModal={openUrlModal}
        />
        <ResourceMaintenanceModal 
            t={t}
            open={showResourceMaintenanceModal} 
            setOpen={setShowResourceMaintenanceModal}  
            resource={resource} 
            setChanged={setChanged}
            fullScreen={fullScreen}
            user={user}
            token={token}
            apiUrl={apiUrl}
            language={language}
            sendMessage={sendMessage}
            handleLogin={handleLogin}
            users={users}
            config={config}
            openUrlModal={openUrlModal}
        />      
        <ResourceBookingModal 
            t={t}
            open={showResourceBookingModal} 
            setOpen={setShowResourceBookingModal}  
            resource={resource} 
            setChanged={setChanged}
            fullScreen={fullScreen}
            user={user}
            token={token}
            apiUrl={apiUrl}
            language={language}
            plans={plans}
            sendMessage={sendMessage}
            handleLogin={handleLogin}
            manage={manage}
        />  
        <div className='tabs-container'>   
            {/*
                tabs?.length > 0 &&
                <Box sx={{position:'sticky',top: 0,zIndex: 1000,bgcolor: 'background.paper'}}>
                    <Tabs                     
                        id="tabs"                
                        sx={sxTabs}                
                        value={tab} 
                        onChange={handleTabChange}
                        variant="scrollable"                    
                    >
                        {
                            tabs?.map((item,index) => (
                                <Tab                    
                                    key={item}                 
                                    icon={<ResourceIcon sx={sxIcon}/>} 
                                    value={item} 
                                    label={t('resources.group.'+tabsNames[index])} 
                                    sx={sx}
                                    //onClick={() => handleTabReClick(item)}
                                />
                            ))
                        }                                    
                    </Tabs>
                </Box>
            */}
            <Backdrop open={groups === null} sx={sxBackdrop}>
                <CircularProgress color="inherit"/>
            </Backdrop>
            <Box sx={{position:'sticky',top: 0,zIndex: 1000,bgcolor: 'background.paper'}}>
                {            
                    groups && groups?.length > 0 &&
                    <div className='mb-4 pt-2'>
                        <Breadcrumbs>
                            <Link
                                underline="hover"
                                sx={sxBreadcrumbsResources}
                                onClick={handleHomeBreadcrumb}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit"/>
                                {t('actions.home.button')}
                            </Link>
                            {
                                group &&                        
                                <Link
                                    underline="hover"
                                    sx={sxBreadcrumbsResources}
                                    onClick={handleGroupBreadcrumb}
                                >
                                    <ResourceIcon sx={{ mr: 0.5 }} fontSize="inherit"/>
                                    {
                                        t('resources.group.'+group?.name) === 'resources.group.'+group?.name ? 
                                            group?.name
                                        :
                                            t('resources.group.'+group?.name)
                                    }
                                </Link> 
                            }  
                            {
                                (subgroup && hasSubgroups) &&
                                <Link
                                    underline="none"
                                    sx={sxBreadcrumbsResources}
                                    onClick={handleSubgroupBreadcrumb}                                        
                                >
                                    <ResourceIcon sx={{ mr: 0.5 }} fontSize="inherit"/>
                                    {
                                        t('resources.subgroup.'+subgroup?.name) === 'resources.subgroup.'+subgroup?.name ? 
                                            subgroup?.name
                                        :
                                            t('resources.subgroup.'+subgroup?.name)
                                    }
                                </Link>
                            }                          
                        </Breadcrumbs>
                    </div>
                }
                {
                    groups && groups?.length > 0 ?
                        !group ? 
                            <>                    
                            <div className='mb-4'>
                                <Card                                   
                                    sx={sxCard}
                                >
                                    <CardActionArea
                                        onClick={() => handleGroup(groupAll)}
                                        sx={sxCardAction}
                                        data-active={group?.id === 0 ? '' : undefined}
                                    >
                                        <CardContent>                                
                                            <div className="text-center font-bold app-color text-2xl">
                                                {t('resources.group.all')}
                                            </div>                                
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </div>
                            <Box sx={{
                                display: 'grid',
                                gap: 2,
                                // [xs, sm, md, lg, xl]
                                gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']
                            }}>
                                {
                                    groups && groups?.length > 0 &&
                                    groups?.map((item) => (
                                        <Card      
                                            key={'resource_group_'+item?.id}                             
                                            sx={sxCard}
                                        >
                                            <CardActionArea
                                                onClick={() => handleGroup(item)}                            
                                                sx={sxCardAction}
                                                data-active={group?.id === item?.id ? '' : undefined}
                                            >
                                                <CardContent>                                
                                                    <div className="text-center font-bold app-color text-2xl">
                                                        {
                                                            t('resources.group.'+item?.name) === 'resources.group.'+item?.name ? 
                                                                item?.name
                                                            :
                                                                t('resources.group.'+item?.name)
                                                        }
                                                    </div>                                
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    ))
                                }
                            </Box>
                            </>                  
                        :
                            (!subgroup && hasSubgroups) ? 
                                <div>                        
                                    <div className='mb-4'>
                                        <Card                                   
                                            sx={{...sxCard,backgroundColor: 'black'}}
                                        >
                                            <CardActionArea
                                                onClick={() => handleBack()}
                                                sx={sxCardAction}                                    
                                            >
                                                <CardContent>                                
                                                    <div className="text-center font-bold text-white text-2xl">
                                                        <BackIcon/> {t('actions.back.button')}
                                                    </div>                                
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </div>
                                    {
                                        group?.id !== 0 &&
                                        <div className='mb-4'>
                                            <Card                                   
                                                sx={sxCard}
                                            >
                                                <CardActionArea
                                                    onClick={() => handleSubgroup(subgroupAll)}
                                                    sx={sxCardAction}
                                                    data-active={subgroup?.id === 0 ? '' : undefined}
                                                >
                                                    <CardContent>                                
                                                        <div className="text-center font-bold app-color text-2xl">
                                                            {t('resources.subgroup.all')}
                                                        </div>                                
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </div>
                                    }
                                    <Box sx={{
                                        display: 'grid',
                                        gap: 2,
                                        // [xs, sm, md, lg, xl]
                                        gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']
                                    }}>
                                        {
                                            subgroups && subgroups?.length > 0 &&                    
                                            subgroups?.filter(item => item?.parent === group?.id)?.map((item) => (
                                                <Card  
                                                    key={'resource_subgroup_'+item?.id}
                                                    sx={sxCard}
                                                >
                                                    <CardActionArea
                                                        onClick={() => handleSubgroup(item)}                            
                                                        sx={sxCardAction}
                                                        data-active={subgroup?.id === item?.id ? '' : undefined}
                                                    >
                                                        <CardContent>                                
                                                            <div className="text-center font-bold app-color text-2xl">
                                                                {
                                                                    t('resources.subgroup.'+item?.name) === 'resources.subgroup.'+item?.name ? 
                                                                        item?.name
                                                                    :
                                                                        t('resources.subgroup.'+item?.name)
                                                                }
                                                            </div>                                
                                                        </CardContent>
                                                    </CardActionArea>
                                                </Card>
                                            ))
                                        }    
                                    </Box>                                           
                                </div>
                            :
                                <div className="noprint flex w-full mb-4 items-center justify-center">                                    
                                    <div 
                                        className="mx-1"
                                    >
                                        <Button                     
                                            onClick={() => handleBack(hasSubgroups ? true : false)}                                            
                                            //type='back'
                                            //text={t('actions.back.button')}
                                            icon={<BackIcon/>}
                                        />
                                    </div>  
                                    <div 
                                        className="mx-1"
                                    >
                                        <Button                     
                                            onClick={handleRefresh}
                                            type='refresh'
                                            //text={t('actions.refresh.button')}
                                            icon={<RefreshIcon/>}
                                        />
                                    </div>                              
                                    <div 
                                        className="mx-1"
                                    >
                                        <Button                     
                                            onClick={handleScroll}
                                            type='up'
                                            //text={t('actions.up.button')}
                                            icon={<UpIcon/>}
                                        />
                                    </div>                                                     
                                </div>
                    :
                        <></>
                }
            </Box>
            {
                group && (group?.id === 0 || !hasSubgroups || subgroup) &&                
                <div ref={resourcesRef} className='w-full'>                                        
                    <div className="noprint flex w-full mb-4 max-md:grid max-md:grid-cols-12 items-center">                             
                        <div className="w-full max-md:col-span-12 max-md:text-center">
                            <Input                      
                                name="search"
                                type="text"
                                value={searchText}                      
                                placeholder={t('filter.placeholder')}
                                autoComplete="search"
                                onChange={handleSearchInput}                                    
                                error=''
                                handleKeyDown={handleSearchKeyDown}
                            />
                        </div>
                        <div className="ml-2 max-md:ml-0 max-md:my-1 max-md:col-span-12 max-md:text-center flex justify-center items-center">                                
                            <div className='mr-1'>
                                <Button                     
                                    onClick={handleSearch}                                        
                                    type='filter'
                                    icon={<FilterIcon/>}
                                />
                            </div>                                
                            <div>
                                <Button    
                                    onClick={() => handleSearchClear(resources,group,subgroup,status,false,true)}
                                    disabled={!filtersApplied}
                                    type='reset'
                                    icon={<FilterOffIcon/>}
                                />
                            </div>
                        </div>                    
                    </div> 
                    {
                        statuses && statuses?.length > 0 &&
                        <div className="noprint flex w-full mb-4 max-md:grid max-md:grid-cols-12 items-center justify-center">
                            {
                                statuses?.map((stat) => (
                                    <div 
                                        key={'resource_rentals_status_'+stat}
                                        className="mx-1 max-md:ml-0 max-md:my-1 max-md:col-span-12 max-md:text-center flex justify-center items-center"
                                    >
                                        <Button                     
                                            onClick={() => 
                                                (stat === status || (stat === 'all' && !status)) ?
                                                    null
                                                :
                                                    handleStatus(stat)
                                            }
                                            type={(stat === status || (stat === 'all' && !status)) ? 'app' : 'appoutlined'}
                                            text={t('resource_rentals.resources.statuses.'+stat)}
                                        />                                        
                                    </div>                    
                                ))
                            }
                        </div>  
                    }                                         
                    <div className='text-center font-bold app-color mb-4 border border-app-color-gradient p-1 rounded app-bg-gradient'>
                        {t('resource_rentals.resources.number')+': '+resourcesFiltered?.length}
                    </div>                
                    <Grid
                        container
                        //spacing={2}
                        rowSpacing={0}
                        columnSpacing={2}
                    >
                    {
                        resourcesFiltered?.map((resource) => (                                                            
                            <Grid key={resource?.id} size={{ xs:12, sm:12, md: 6, xl: 4 }}>
                                <Resource
                                    t={t} 
                                    resource={resource}                                            
                                    handleResourceRental={handleResourceRental}
                                    handleResourceInfo={handleResourceInfo}
                                    handleResourceEvents={handleResourceEvents}
                                    handleResourceMaintenance={handleResourceMaintenance}
                                    handleResourceBooking={handleResourceBooking}
                                    openUrlModal={openUrlModal}
                                    manage={manage}
                                    sendMessage={sendMessage}
                                />
                            </Grid>
                        ))
                    }
                    </Grid>
                </div>
            }
        </div>    
        </>
    );
}